import type { OfferLineTemplate } from "@/hooks/use-offers";
import type { OfferPhase } from "@/lib/offer-calc";

export const PHASE_OPTIONS: Array<{ value: OfferPhase; label: string }> = [
  { value: "pl", label: "Prosjektledelse" },
  { value: "preprod", label: "Preproduksjon" },
  { value: "production", label: "Produksjon" },
  { value: "postprod", label: "Postproduksjon" },
  { value: "stills", label: "Stills" },
  { value: "reise", label: "Reise" },
];

export const COST_TYPES = [
  { value: "internal", label: "Intern" },
  { value: "external", label: "Ekstern" },
];

export const PRICING_TYPES = [
  { value: "hourly", label: "Time" },
  { value: "fixed", label: "Fast" },
];

export const UNITS = ["t", "d", "stk", "natt", "dag", "fast"];

export type Draft = Partial<OfferLineTemplate> & { id?: string };
